import { types, actions } from './requests'
export const CREATEMACHINETYPE_TYPES = {
    ...types('CREATEMACHINETYPE'),
}
export const CREATEMACHINETYPE_ACTIONS = {
    ...actions('CREATEMACHINETYPE'),
}
